import { LS_ATTRIBUTION } from "appConfig";
import { AccountAttribution } from "model/account";

var ls = require("local-storage");


export const findCampaign = (href: string): string | undefined => {
  if (!href) return undefined;

  const idx = Math.max(href.indexOf("?c="), href.indexOf("&c="));
  if (idx < 0) return undefined;

  const idxNext = href.indexOf("&", idx + 1);
  const idxFragment = href.indexOf("#", idx + 1);

  if (idxNext > 0)
    return href.substring(idx + 3, idxNext);

  if (idxFragment > 0)
    return href.substring(idx + 3, idxFragment);

  return href.substring(idx + 3);
}


export const getAttribution = (href: string, analytics_cookie: boolean): AccountAttribution => {

  const referrer = document.referrer || "";
  const onelinkReferer = referrer.startsWith("https://onelink.to/") || referrer.startsWith("http://onelink.to/");

  let attribution: AccountAttribution = {};

  if (analytics_cookie) {
    const json_string = ls.get(LS_ATTRIBUTION);

    if (json_string) try {
      attribution = JSON.parse(json_string);
    } catch (err) { }
  }

  if (!attribution.first_visit) attribution.first_visit = Math.round(new Date().getTime() / 1000);
  if (!attribution.visit_count) attribution.visit_count = 0;

  attribution.visit_count++;
  let campaign = findCampaign(href);
  if (!campaign && !attribution.campaign && onelinkReferer) campaign = "onelink.to";
  if (campaign) attribution.campaign = campaign;
  if (referrer) attribution.referrer = referrer;
  attribution.href = href;


  if (analytics_cookie) {
    try {
      const json_string = JSON.stringify(attribution);
      ls.set(LS_ATTRIBUTION, json_string);
    } catch (err) { }
  }

  return attribution;
}

